import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductFileExportWrapper } from '../../models/product-file-export';

@Injectable({
  providedIn: 'root'
})
export class ProductFileExportService {
  protected baseUrl = 'json/product-file-export';

  constructor(protected http: HttpClient) {}

  getAll(nocache?: boolean): Observable<ProductFileExportWrapper[]> {
    const headers = new HttpHeaders().set('maxAge', nocache ? '-1' : '300');
    return this.http.get<ProductFileExportWrapper[]>(this.baseUrl, { headers });
  }

  getOne(id: string, nocache?: boolean): Observable<ProductFileExportWrapper> {
    const url = `${this.baseUrl}/${encodeURIComponent(id)}`;
    const headers = new HttpHeaders().set('maxAge', nocache ? '-1' : '300');
    return this.http.get<ProductFileExportWrapper>(url, { headers });
  }

  save(wrapper: ProductFileExportWrapper): Observable<ProductFileExportWrapper> {
    return this.http.post<ProductFileExportWrapper>(this.baseUrl, wrapper);
  }

  delete(id: string): Observable<void> {
    const url = `${this.baseUrl}/${encodeURIComponent(id)}`;
    return this.http.delete<void>(url);
  }
}
